import { PumpeCCActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const PumpeCCReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case PumpeCCActionType.PumpeCC_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default PumpeCCReducer
